import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ContentVoiceOver from './ContentVoiceOver';
import ContentAudioArticle from './ContentAudioArticle';
import Installation from './integration/Installation';
import Player from './integration/Player';
import General from './integration/General';
import Profile from './profile/Profile';
import Organisation from './Organisation';
import Integration from './Integration';
import RouteWrapper from '../components/RouteWrapper';
import FullWidthLayout from '../components/FullWidthLayout';
import FullWidthLayoutFlex from '../components/FullWidthLayoutFlex';
import SideBarLayout from '../components/SideBarLayout';
import Overview from './analytics/Overview';
import ContentAnalytics from './analytics/ContentAnalytics';
import Billing from './Billing';
import Plans from './plans/Plans';
import ChangePlan from './plans/ChangePlan';
import Podcast from './Podcast';
import CreatePodcast from './CreatePodcast';
import EditPodcast from './EditPodcast';
import CreateContent from './CreateContent';
import WordPress from './installation/WordPress';
import OtherCMS from './installation/OtherCMS';
import Listen2ItAPI from './installation/API';
import WelcomePage from './WelcomePage'
import Dashboard from './Dashboard'
import PodcastAudios from './PodcastAudios';
import OnboardingWork from './onboarding/OnboardingWork';
import OnboardingAudio from './onboarding/OnboardingAudio';
import AddContentToPodcast from './AddContentToPodast';
import CancelableFullWidthLayout from '../components/CancelableFullWidthLayout';
import Error404 from '../components/error/404';
import AIVoices from './AIVoices';
import AIVoicesV2 from './AIVoicesV2';
import SavedProfiles from './SavedProfiles';
import InstantVoiceClone from './InstantVoiceClone';
import SoundEffectsPage from './SoundEffectsPage';
import MusicPage from './MusicPage';
import Dubbing from './Dubbing';
import VoiceChanger from './VoiceChanger';
import VoiceIsolator from './VoiceIsolator';
import { useAuthStore } from '../zustand-store/useAuthStore';
import { useGlobalStore } from '../zustand-store/useGlobalStore';
import { useOnURLChangeListener } from '../hooks/useOnURLChangeListener';
import BootLoadingScreen from '../components/BootLoadingScreen';
import PageViewTracker from '../components/PageViewTracker';
import QualityRatingPrompt from '../components/feedback/QualityRatingPrompt';
// Dynamic import for EditContent to prevent CSS loading on other pages
const EditContent = React.lazy(() => import('./EditContent'));


export default function ProtectedRoutes(){
    const { user } = useAuthStore();

    return(
        <Router>
            <Wrapper>
                <Switch>
                    <RouteWrapper exact path="/" component={Organisation} layout={FullWidthLayout} />
                    <RouteWrapper exact path="/profile" component={Profile} layout={FullWidthLayout} />
                    <RouteWrapper exact path="/organisation/:org_id/integration" component={Integration} layout={FullWidthLayout} />
                    <RouteWrapper exact path="/organisation/:org_id/plans" component={Plans} layout={FullWidthLayout}/>
                    <RouteWrapper exact path="/profile" component={Profile} layout={FullWidthLayout} />
                    <Route exact path="/organisation/:org_id/integration/:id/content/new" >
                        <CreateContent />
                    </Route>
                    <RouteWrapper exact path="/organisation/:org_id/upgrade" component={ChangePlan} layout={CancelableFullWidthLayout}/>
                    <RouteWrapper exact path="/organisation/:org_id/welcome" component={WelcomePage} layout={FullWidthLayoutFlex} />
                    <RouteWrapper exact path="/organisation/:org_id/integration/:id/dashboard" component={Dashboard} layout={SideBarLayout} />
                    <RouteWrapper exact path="/onboarding/work" component={OnboardingWork} layout={FullWidthLayout} />
                    <RouteWrapper exact path="/onboarding/audio" component={OnboardingAudio} layout={FullWidthLayout} />
                    <Switch>
                        <Route exact path="/organisation/:org_id/integration/:id/content/:content_id" render={({ match }) => (
                            <React.Suspense fallback={<BootLoadingScreen text="Initializing Studio" />}>
                                <EditContent key={match.params.content_id} />
                            </React.Suspense>
                        )} />
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/billing" component={Billing} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/content" component={ContentVoiceOver} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/content-audio-articles" component={ContentAudioArticle} layout={SideBarLayout}/>
                        <RouteWrapper path="/organisation/:org_id/integration/:id/installation" component={Installation} layout={SideBarLayout} />
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/voice/instant-voice-clone" component={InstantVoiceClone} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/voice" component={AIVoicesV2} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/dubbing" component={Dubbing} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/voice-changer" component={VoiceChanger} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/voice-isolator" component={VoiceIsolator} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/sound-effects" component={SoundEffectsPage} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/music" component={MusicPage} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/profiles" component={SavedProfiles} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/player" component={Player} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/general" component={General} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/analytics_overview" component={Overview} layout={SideBarLayout} />
                        <RouteWrapper path="/organisation/:org_id/integration/:id/content_analytics" component={ContentAnalytics} layout={SideBarLayout} />

                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/podcast" component={Podcast} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/podcast/new" component={CreatePodcast} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/podcast/:podcast_id" component={EditPodcast} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/podcast/:podcast_id/episodes" component={PodcastAudios} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/podcast/:podcast_id/episodes-add" component={AddContentToPodcast} layout={SideBarLayout}/>

                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/wordpress" component={WordPress} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/cms" component={OtherCMS} layout={SideBarLayout}/>
                        <RouteWrapper exact path="/organisation/:org_id/integration/:id/api" component={Listen2ItAPI} layout={SideBarLayout}/>
                        <Route component={Error404}></Route>
                    </Switch>
                </Switch>
            </Wrapper>
        </Router>
    )
}

const Wrapper = ({ children }) => {

    useOnURLChangeListener(
        (pathname) => pathname.includes('/content/'),
        (isContentScreen) => {
            if (isContentScreen) {
                window.$crisp.push(['do', 'chat:hide']);
            } else {
                window.$crisp.push(['do', 'chat:show']);
            }
        }
    );
    
    // ✨ Update global store with IDs from URL for mixpanel tracking (on mount and route changes)
    useOnURLChangeListener(
        (pathname) => pathname, // Just pass the pathname
        (pathname) => {
            const { setOrgId, setIntegrationId, setContentId } = useGlobalStore.getState();
            
            // Extract IDs from URL pattern: /organisation/:org_id/integration/:id/content/:content_id
            const match = pathname.match(/\/organisation\/([^/]+)\/integration\/([^/]+)(?:\/content\/([^/]+))?/);
            
            if (match) {
                const [, orgId, integrationId, contentId] = match;
                setOrgId(orgId || '');
                setIntegrationId(integrationId || '');
                setContentId(contentId || '');
            } else {
                // If not on integration route, clear the IDs
                setOrgId('');
                setIntegrationId('');
                setContentId('');
            }
        }
    );

    return (
        <>
            <PageViewTracker />
            {children}
            {/* Single app-wide instance of the shared quality-rating prompt; any
                feature fires requestQualityRating() and it renders here. */}
            <QualityRatingPrompt />
        </>
    )
}
